export default class HttpError extends Error {
	public status: number;
	public statusText: string;
	public result: any;

	constructor(status: number, statusText: string, result: any) {
		super(statusText);
		this.status = status;
		this.statusText = statusText;
		this.result = result;
		Object.setPrototypeOf(this, HttpError.prototype);
	}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/errors/http.ts